import { runGetApiRequest } from 'services/Api';

import { GET_USERS } from 'constants/apiRoutes';

export const getUsers = () => (
  runGetApiRequest(GET_USERS)
);
